import * as React from 'react';
import type { ReactNode } from 'react';
import styles from './Filters.module.css';
import { FiltersWrapper } from './FiltersWrapper';

interface SimpleFiltersTranslations {
    filters: string;
}

interface FiltersProps {
    translations: SimpleFiltersTranslations;
    children: ReactNode;
}

export const SimpleFilters: React.FunctionComponent<React.PropsWithChildren<FiltersProps>> = ({
    translations,
    children,
}) => (
    <FiltersWrapper translations={translations} wrapper={false}>
        <div className={styles.Content}>{children}</div>
    </FiltersWrapper>
);
